import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

import { expVal } from '@confluence/feature-experiments';

/**
 * Keeps the standard palette rollout condition inside the tab-color feature.
 */
export const isStandardTabColorPaletteEnabled = (): boolean =>
	expValEquals('platform_editor_lovability_text_bg_color', 'isEnabled', true) &&
	expVal('confluence_native_tabs_m15', 'isEnabled', false);
